import API_URL from '../apiUrl'
import environmentPartitionIdMap from '../partitionIdMap'
import axios from 'axios'
import { keys, each, includes } from 'lodash'

function checkPortability (phoneNumber) {
  const partitionId = environmentPartitionIdMap[API_URL.getEnv()]
  const urlBase = constructUrl('anonymous/portable?partitionId=:partitionId&tn=:tn', {
    values: {
      partitionId,
      tn: phoneNumber
    }
  })

  return axios.get(urlBase)
}

function getLogo (subDomain, defaultLogo) {
  subDomain = subDomain || window.serverConfig.subDomain || window.location.hostname
  if (!includes(subDomain, 'user')) {
    return defaultLogo
  }
  return `${API_URL.getAPIUrl()}anonymous/theme/${subDomain}/logo`
}

function getWhiteLabelData (domain) {
  const urlBase = constructUrl('anonymous/theme/:domain', {
    values: {
      domain
    }
  })
  return axios.request({
    url: urlBase,
    transformResponse: response => {
      const parsedResponse = JSON.parse(response)
      parsedResponse.azData = { notifications: null }
      return parsedResponse
    }
  })
}

function constructUrl (url, config = {}) {
  const { queryParams, values } = config
  let resultUrl = `${API_URL.getAPIUrl()}${url}`
  if (queryParams) {
    resultUrl = appendQueryParams(queryParams, resultUrl)
  }
  if (values) {
    resultUrl = replaceVariables(values, resultUrl)
  }
  return resultUrl
}

function replaceVariables (variables, url) {
  let newUrl = `${url}`
  const variableKeys = keys(variables)
  each(variableKeys, key => {
    newUrl = newUrl.replace(`:${key}`, variables[key])
  })
  return newUrl
}

function appendQueryParams (queryParams, url) {
  const newUrl = `${url}`
  const queryParamKeys = keys(queryParams)
  let addition = ''
  each(queryParamKeys, (key, index) => {
    if (index !== 0) {
      addition = `${addition}&`
    }
    addition = `${addition}${key}=${queryParams[key]}`
  })
  return `${newUrl}?${addition}`
}

export {
  constructUrl,
  getWhiteLabelData,
  getLogo,
  checkPortability
}



// WEBPACK FOOTER //
// ./src/lib/ALIANZA_API_V2/ALIANZA_API_V2.js